<template>
  <NuxtLayout name="center">
    <div class="md:flex md:max-w-[1061px]" v-if="data">
      <div class="rounded md:w-2/5 md:mr-4">
        <NuxtLinkLocale :locale="switchBlogLocale(true)" :to="slug">
          <NuxtImg
            loading="lazy"
            class="object-cover rounded max-w-[407px] w-full max-h-[180px] md:max-h-52 h-full"
            :src="blogImage"
            :alt="blogImageAlt"
            wdidth="300"
            height="152"
          />
        </NuxtLinkLocale>
      </div>
      <div class="flex-col md:w-3/5">
        <div class="h-5/6 pb-4">
          <div class="flex text-blog-12-sm md:text-blog-14">
            <NuxtLinkLocale
              v-if="props.data.categories"
              :locale="switchBlogLocale(true)"
              class="text-primary font-bold"
              :to="categoryUrl"
            >
              {{ props.data.categories.name }}
            </NuxtLinkLocale>
            <span class="text-dark-blue-light ml-auto font-semibold">{{ props.data.post_date }}</span>
          </div>
          <div class="flex text-blog-16-sm mb-3 font-bold md:text-blog-22 text-secondary">
            <NuxtLinkLocale :locale="switchBlogLocale(true)" :to="slug">
              {{ props.data.title }}
            </NuxtLinkLocale>
          </div>
          <p class="pb-4 pt-1 text-blog-14-sm md:text-blog-19 text-left">
            {{ blogContent }}
          </p>
        </div>
        <div class="font-semibold">
          <span v-if="props.data.author" class="text-dark-blue-light text-blog-14">
            {{ $t("blog.byAuthor") }}
            <NuxtLinkLocale :locale="switchBlogLocale(true)" :to="authorUrl">
              {{ props.data.author.display_name }}
            </NuxtLinkLocale>
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <BlogSkeleton></BlogSkeleton>
    </div>
  </NuxtLayout>
</template>

<script setup>
const { $truncate } = useNuxtApp();
const props = defineProps({
  data: {
    type: Object,
  },
});
const slug = `/blog/${props.data.slug}`;
const authorUrl = `/blog/authors/${props.data.author?.slug ?? ""}`;
const blogContent = $truncate(props.data.intro, 150, `...`);
const categoryUrl = `/blog/categories/${props.data.categories?.slug ?? ""}`;
const blogImage = getBlogImage(props.data.image, "img_large");
const blogImageAlt = props.data.image?.img_alt || props.data.title;
</script>
